import type { AttendanceShiftStatusView, ClockAttendanceActionRequest, PublicAttendanceActionView, PublicAttendanceEmployeesPage, PublicAttendancePrinter, PublicAttendancePrintSlipRequest, PublicAttendanceSlipRequest } from 'shared-models/browser';
import { validateEnv } from '../../utils/env.util';

async function request<Result>(tenantId: string, key: string, path: string, options?: RequestInit): Promise<Result> {
  const base = validateEnv().VITE_BACKEND_LOCATION.replace(/\/$/, '');
  const response = await fetch(`${base}/attendance/public/${encodeURIComponent(tenantId)}${path}`, {
    ...options, credentials: 'omit', cache: 'no-store',
    headers: { 'x-attendance-key': key, ...(options?.body ? { 'Content-Type': 'application/json' } : {}) },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = body.message === 'EMPLOYEE_REPORT_REQUIRED' ? 'יש להפיק דוח עובד בקופה לפני היציאה ממשמרת'
      : body.message === 'Invalid employee pin' ? 'קוד עובד שגוי'
      : response.status === 429 ? 'יותר מדי ניסיונות. נסו שוב בעוד דקה.'
      : typeof body.message === 'string' && /[֐-׿]/.test(body.message) ? body.message : 'הנוכחות אינה זמינה כרגע. נסו שוב או פנו למנהל.';
    throw new Error(message);
  }
  if (response.status === 204) return undefined as Result;
  return response.json() as Promise<Result>;
}

export const attendancePublicService = {
  employees: (tenantId: string, key: string, cursor = 0, signal?: AbortSignal) =>
    request<PublicAttendanceEmployeesPage>(tenantId, key, `/employees?cursor=${cursor}&limit=50`, { signal }),
  status: (tenantId: string, key: string, employeeId: number) =>
    request<AttendanceShiftStatusView>(tenantId, key, `/employee/${employeeId}/shift-status`),
  clock: (tenantId: string, key: string, payload: ClockAttendanceActionRequest) =>
    request<PublicAttendanceActionView>(tenantId, key, '/clock-action', { method: 'POST', body: JSON.stringify(payload) }),
  slipPrinters: (tenantId: string, key: string, payload: PublicAttendanceSlipRequest) =>
    request<PublicAttendancePrinter[]>(tenantId, key, '/slip-printers', { method: 'POST', body: JSON.stringify(payload) }),
  printSlip: (tenantId: string, key: string, payload: PublicAttendancePrintSlipRequest) =>
    request<void>(tenantId, key, '/print-slip', { method: 'POST', body: JSON.stringify(payload) }),
};